import { Button, Col, Form, Input } from 'antd';
import React, { FunctionComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styled from './IndigoSearchForm.styled';

export interface IndigoSearchFormProps {
  onChange?: (value: string) => void;
  onSearch: (value: string) => void;
  value?: string;
  placeholder?: string;
  searchButtonText?: string;
  requireValidation?: boolean;
}

export interface IndigoSearchFormValue {
  value: string;
}

export const IndigoSearchForm: FunctionComponent<IndigoSearchFormProps> = ({
  onChange,
  onSearch,
  placeholder = 'Type some thing to search...',
  searchButtonText = 'Search',
  value,
  requireValidation,
}) => {
  const handleSearchChanged = (value: string) => {
    if (onChange) {
      onChange(value);
    }
    if (value === '') {
      onSearch(value || '');
    }
  };

  const onSubmitSearch = (value: IndigoSearchFormValue) => {
    onSearch(value.value || '');
  };

  return (
    <Form
      initialValues={{
        value,
      }}
      onFinish={e => onSubmitSearch(e as IndigoSearchFormValue)}
    >
      <Styled.Row
        gutter={[20, 20]}
        className="indigo-filter-header"
        align="top"
      >
        <Col>
          <Form.Item
            rules={[
              {
                required: requireValidation,
                message: 'Please fill in your name!',
              },
            ]}
            name="value"
          >
            <Input
              className="search-input"
              placeholder={placeholder}
              prefix={<FontAwesomeIcon icon={['fal', 'search']} />}
              onChange={e => handleSearchChanged(e.target.value)}
              allowClear
            ></Input>
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} lg={4}>
          <Button htmlType="submit" className="search-btn">
            {searchButtonText}
          </Button>
        </Col>
      </Styled.Row>
    </Form>
  );
};
